import { render, staticRenderFns } from "./repositoryView.vue?vue&type=template&id=b390359c&scoped=true&"
import script from "./repositoryView.vue?vue&type=script&lang=js&"
export * from "./repositoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b390359c",
  null
  
)

export default component.exports